<form name="accountForm">
  <div class="tw-flex tw-flex-col tw-gap-4">
    <!--    institution-->
    @if (!isStockOrOther()) {
      @if (showInstitutionSelect()) {
        <div class="tw-flex tw-flex-col tw-gap-1">
          <app-dropdown-search
            [options]="institutionNames()"
            [placeholder]="institutionSearchPlaceholder()"
            [label]="'institutionBank' | i18n"
            (optionSelected)="onInstitutionSelected($event)"
            (cleared)="onInstitutionCleared()"
            [isRequired]="true"
            [preSelected]="selectedInstitutionName()"
            [taggedOptions]="taggedManualInstitutions()"
            [manualTouched]="institutionTouched()"
            [leadingDropdownEnabled]="true"
            [leadingOptions]="countryNames()"
            [leadingSelected]="selectedCountryName()"
            [leadingOptionCodes]="countryCodes()"
            [leadingPlaceholder]="'country' | i18n"
            (leadingOptionSelected)="onCountrySelected($event)"
          ></app-dropdown-search>

          @if (institutionsIsRefreshing()) {
            <p>{{ "loading" | i18n }}</p>
          } @else {
            <span
              class="tw-cursor-pointer tw-font-normal tw-tracking-[0.0125em] tw-underline tw-text-neutral-600"
              (click)="onAddInstitution()"
            >
              {{ "notFoundInstitutionsAddManually" | i18n }}
            </span>
          }
        </div>
      } @else {
        <app-dropdown-select
          [class.tw-pointer-events-none]="isFormDisabled()"
          [label]="'institutionBank' | i18n"
          [isRequired]="true"
          [isEnabled]="false"
          [selectedOption]="selectedInstitution()?.name ?? ''"
          [options]="[selectedInstitution()?.name ?? '']"
          [placeholder]="institutionPlaceholder()"
          [customShadowClass]="'tw-shadow-dropdown'"
          [showGradientBorder]="false"
        >
        </app-dropdown-select>
      }
    }

    @if (isSyncedAccount()) {
      <!--    accountNickname (only for synced/fetched accounts) -->
      <app-input
        [class.tw-pointer-events-none]="isReadOnly()"
        [value]="accountNickname()"
        [label]="'accountNickname' | i18n"
        [isRequired]="false"
        [isDisabled]="isReadOnly()"
        [placeholder]="'accountNicknamePlaceholder' | i18n"
        maxlength="50"
        (outputValue)="onAccountNicknameChanged($event)"
      ></app-input>
    }

    <!--   currency-->
    <app-currencies
      [detachPanel]="true"
      [class.tw-pointer-events-none]="isFormDisabled()"
      class="tw-w-full tw-font-neutral-800 tw-mb-3 [&_label]:tw-mb-1"
      (onSelectCurrency)="onSelectCurrency($event)"
      [label]="'Currency'"
      [disabled]="!isCurrencyEditMode() || isFormDisabled()"
      [defaultCurrency]="currency()"
      [detachPanel]="true"
    ></app-currencies>

    @if (!isStockOrOther()) {
      <!--    accountProduct (disabled until an institution is selected; clicking it while
              disabled surfaces the institution required error) -->
      <div (click)="onAccountProductClick()">
        <app-institutional-accounts
          [class.tw-pointer-events-none]="isAccountProductDisabled()"
          class="tw-font-neutral-800 tw-mb-3 [&_label]:tw-mb-1"
          [institution]="selectedInstitution()"
          (selectedInstitutionAccount)="onSelectAccountProduct($event)"
          [preselectedInstitutionalAccount]="selectedAccountProduct()"
          [isAppendRatesRange]="accountType() === accountManualTypeRef.bank"
          [disabled]="isAccountProductDisabled()"
          [isRequired]="!isFormDisabled()"
          [placeholder]="accountProductPlaceholder()"
          [customShadowClass]="'tw-shadow-elevation-input'"
          [showGradientBorder]="false"
        ></app-institutional-accounts>
      </div>
    }

    <!--    accountName-->
    <app-input
      [class.tw-pointer-events-none]="isFormDisabled()"
      [value]="accountName()"
      [label]="'accountName' | i18n"
      [isRequired]="!isFormDisabled()"
      [isDisabled]="isFormDisabled()"
      [placeholder]="accountNameDisplayPlaceholder()"
      (outputValue)="onAccountNameChanged($event)"
    >
    </app-input>

    @if (showFooter()) {
      <modal-footer [isFullWidth]="true">
        @if (!isEditMode() && !inWizard()) {
          <!-- Create flow: Cancel + Create -->
          <div class="tw-flex tw-gap-4 tw-w-full md:tw-flex-col tw-justify-end">
            <button
              type="button"
              (click)="onCancel()"
              class="tw-flex tw-h-[48px] tw-items-center tw-justify-center tw-px-8 tw-rounded-[60px] tw-shadow-neuomorphic-raised-soft"
            >
              <span
                class="tw-font-medium tw-text-[20px] sm:tw-text-[18px] tw-tracking-[0.005em] tw-leading-[135%] tw-text-dt-text-headings"
                >{{ "cancel" | i18n }}</span
              >
            </button>

            <button
              type="button"
              (click)="onCreate()"
              class="tw-flex tw-h-[48px] tw-w-full tw-items-center tw-justify-center tw-px-6 tw-rounded-[50px] tw-bg-dt-surface-on-action tw-shadow-button-shadow tw-max-w-[300px] md:tw-max-w-none"
            >
              <span
                class="tw-font-medium tw-text-[20px] sm:tw-text-[18px] tw-tracking-[0.005em] tw-leading-[135%] tw-text-dt-slate-0 tw-whitespace-nowrap"
                >{{ "create" | i18n }}</span
              >
            </button>
          </div>
        } @else {
          <!-- Edit / wizard: single save button -->
          <app-gloss-button
            [options]="finalSaveButtonOptions()"
            class="tw-w-full"
          ></app-gloss-button>
        }
      </modal-footer>
    }
  </div>
</form>
